module.exports = __webpack_public_path__ + "static/img/baas_channel_2.3946d9f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_channel_2.svg
// module id = 9lxU
// module chunks = 0